<!--
 * @Author: Latte
 * @Date: 2021-08-05 11:10:59
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-11 14:34:05
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\roleApplicationMgt\index.vue
-->

<template>
  <div class="app-container">
    <!-- 会诊角色申请管理 -->
    <el-table
      ref="table"
      border
      :data="allRoleApplicationList"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      v-loading="loading"
    >
      <el-table-column
        prop="consultationUserReqID"
        label="会诊用户 ID"
        width="100"
      ></el-table-column>
      <el-table-column label="申请人姓名" width="150">
        <template slot-scope="scope">
          {{ formatName(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">{{
          scope.row.createTime | formatDateTime
        }}</template>
      </el-table-column>
      <el-table-column label="工作地点">
        <template slot-scope="scope">
          {{ formatPlace(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="company" label="申请单位"></el-table-column>
      <el-table-column prop="role" label="申请角色">
        <template slot-scope="scope">
          {{ formatRole(scope.row.role) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        label="拒绝原因"
        width="150"
      ></el-table-column>
      <el-table-column
        label="申请状态"
        prop="auditStatus"
        width="200px"
        align="center"
        :filters="[
          { text: '未审核', value: 0 },
          { text: '已通过', value: 1 },
          { text: '已拒绝', value: 2 },
        ]"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <el-tag size="medium" :type="getStatusType(scope.row)">{{
            formatStatus(scope.row)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400px" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.stop="goDetail(scope.row)"
            >查看详情</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click.stop="allowApplication(scope)"
            :disabled="scope.row.auditStatus === 0 ? false : true"
            >通过认证</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click.stop="openRefuseDialog(scope.row)"
            :disabled="scope.row.auditStatus === 0 ? false : true"
            >拒绝认证</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-show="totalCount > pageSize"
      background
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import {
  getAllRoleApplication,
  getAllRoleList,
  getRoleDetail,
  deleteRole,
  deleteRoleApplication,
  resumeRoleApplication,
  updateRoleApplication,
} from "@/api/system/diagnosisManagement/diagnosticRoleApplication";

import { handleRes } from "@/utils/handleRes";
export default {
  data() {
    return {
      loading: false, // 加载开关
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      refuseDialog: false, // 拒绝用户申请对话框
      allRoleApplicationList: [],
      refuseReason: "", // 拒绝用户申请原因
      refuseApplicationForm: {}, // 拒绝用户申请表单
    };
  },

  computed: {
    /**
     * @description: 格式化名称
     * @param {*}
     * @return {*}
     */
    formatName: {
      get() {
        return function (row) {
          let fullName = row.firstName + row.lastName;
          return fullName;
        };
      },
    },

    /**
     * @description: 格式化工作地点
     * @param {*}
     * @return {*}
     */
    formatPlace: {
      get() {
        return function (row) {
          let fullWorkPlace =
            row.workProvince + row.workCity + row.workDistrict;
          return fullWorkPlace;
        };
      },
    },

    /**
     * @description: 获取 申请状态tag类型
     * @param {*}
     * @return {*}
     */
    getStatusType: {
      get() {
        return function (row) {
          switch (row.auditStatus) {
            case 0:
              return "primary";
            case 1:
              return "success";
            case 2:
              return "info";
          }
        };
      },
    },

    /**
     * @description: 格式化申请状态
     * @param {*}
     * @return {*}
     */
    formatStatus: {
      get() {
        return function (row) {
          switch (row.auditStatus) {
            case 0:
              return "待审核";
            case 1:
              return "已通过";
            case 2:
              return "已拒绝";
          }
        };
      },
    },

    /**
     * @description: 格式化申请角色
     * @param {*}
     * @return {*}
     */
    formatRole() {
      return function (row) {
        switch (row) {
          case 0:
            return "医生";
          case 1:
            return "会诊专家";
          case 2:
            return "医生&会诊专家";
        }
      };
    },
  },

  created() {
    this.refreshCurrentList();
  },

  methods: {
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.getAllRoleApplication();
    },

    /**
     * @description: 翻页
     * @param {*} currentPage
     * @return {*}
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },

    /**
     * @description: 筛选
     * @param {*} value
     * @param {*} row
     * @param {*} column
     * @return {*}
     */
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    /**
     * @description: 获取角色申请列表
     * @param {*}
     * @return {*}
     */
    getAllRoleApplication() {
      this.loading = true;
      const params = {
        keyword: "",
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        sortName: "",
        sortOrder: "",
      };
      getAllRoleApplication(params).then((res) => {
        this.allRoleApplicationList = res.data.list;
        this.totalCount = res.data.total;

        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 通过申请
     * @param {*} scope
     * @return {*}
     */
    allowApplication(scope) {
      const data = {
        auditStatus: 1,
        consultationUserReqID: scope.row.consultationUserReqID,
        reason: "",
      };

      updateRoleApplication(data).then((res) => {
        console.log("res", res);
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getAllRoleApplication();
      });
    },

    /**
     * @description: 打开拒绝认证对话框
     * @param {*} row
     * @return {*}
     */
    openRefuseDialog(row) {
      this.refuseDialog = true;
      this.refuseApplicationForm = row;
    },

    /**
     * @description: 拒绝用户申请
     * @param {*}
     * @return {*}
     */
    refuseApplication() {
      this.loading = true;
      const refuseReason = this.refuseReason;
      if (refuseReason === "") {
        this.$message({
          message: "拒绝原因不能为空!",
          type: "error",
          center: true,
          showClose: true,
        });
        this.utils.stopLoading(this);
      } else {
        this.loading = true;
        const data = {
          auditStatus: 1,
          consultationUserReqID:
            this.refuseApplicationForm.consultationUserReqID,
          reason: refuseReason,
        };

        updateRoleApplication(data).then((res) => {
          console.log("res", res);
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getAllRoleApplication();
          this.refuseDialog = false;
          this.utils.stopLoading(this);
        });
      }

      this.utils.stopLoading(this);
    },

    /**
     * @description: 打开拒绝申请对话框(已废弃)
     * @param {*} scope
     * @return {*}
     */
    // openCancelMessage(scope) {
    //   this.$confirm("此操作将永久删除该会诊角色, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.deleteRole(scope);
    //       console.log("success!!!");
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除",
    //       });
    //     });
    // },

    /**
     * @description: 跳转角色申请详情
     * @param {*} row
     * @return {*}
     */
    goDetail(row) {
      console.log(" ------------------");
      console.log("goDetail , row", row);
      console.log(" ------------------");
      this.$router.push({
        name: "diagnosticUserDetail",
        params: {
          userDetail: row,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.operation {
  display: inline-block;
  margin-right: 10px;
}
</style>